import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "license-content"
}
const _hoisted_2 = { class: "license-text" }
const _hoisted_3 = { class: "license-text" }
const _hoisted_4 = { class: "license-text" }
const _hoisted_5 = { class: "license-text" }
const _hoisted_6 = { class: "license-text" }
const _hoisted_7 = { class: "flex justify-center" }
const _hoisted_8 = { class: "app-license" }
const _hoisted_9 = { class: "doc-link-wrap flex justify-center" }

import { usePopupStore } from '@/store'


export default {
  __name: 'LicenseFooter',
  props: ['color', 'showExtraInfo'],
  setup(__props) {



const popupStore = usePopupStore();

return (_ctx, _cache) => {
  const _component_van_image = _resolveComponent("van-image")

  return (_openBlock(), _createElementBlock("div", {
    class: "license-footer",
    style: _normalizeStyle({ color: __props.color })
  }, [
    (__props.showExtraInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.$t('license.content.row1')) + " ", 1),
            _createElementVNode("span", {
              class: "highlight",
              onClick: _cache[0] || (_cache[0] = $event => (_unref(popupStore).openDocument('terms_of_use')))
            }, _toDisplayString(_ctx.$t('ageVerification.termsAndCondition')), 1)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.$t('license.content.row2')) + " ", 1),
            _createElementVNode("span", {
              class: "highlight",
              onClick: _cache[1] || (_cache[1] = $event => (_unref(popupStore).openDocument('privacy_policy')))
            }, _toDisplayString(_ctx.$t('ageVerification.privacyPolicy')), 1)
          ]),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('license.content.row3')), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('license.content.row4')), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('license.content.row5')), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_van_image, {
        class: "logo-pagcor",
        src: require('@/assets/img/common/logo-pagcor-white-text.png')
      }, null, 8, ["src"]),
      _createVNode(_component_van_image, {
        class: "logo-responsible",
        src: require('@/assets/img/common/logo-responsible-white-text.png')
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('license.copyright')), 1),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", {
        class: "doc-link",
        onClick: _cache[2] || (_cache[2] = $event => (_unref(popupStore).openDocument('about_us')))
      }, _toDisplayString(_ctx.$t('footer.doc.aboutUs')), 1),
      _createElementVNode("div", {
        class: "doc-link",
        onClick: _cache[3] || (_cache[3] = $event => (_unref(popupStore).openDocument('terms_of_use')))
      }, _toDisplayString(_ctx.$t('footer.doc.terms')), 1),
      _createElementVNode("div", {
        class: "doc-link",
        onClick: _cache[4] || (_cache[4] = $event => (_unref(popupStore).openDocument('privacy_policy')))
      }, _toDisplayString(_ctx.$t('footer.doc.privacy')), 1),
      _createElementVNode("div", {
        class: "doc-link",
        onClick: _cache[5] || (_cache[5] = $event => (_unref(popupStore).openDocument('responsible_gaming')))
      }, _toDisplayString(_ctx.$t('footer.doc.responsibleGaming')), 1),
      _createElementVNode("div", {
        class: "doc-link",
        onClick: _cache[6] || (_cache[6] = $event => (_unref(popupStore).openDocument('kyc_verification')))
      }, _toDisplayString(_ctx.$t('footer.doc.kycVerification')), 1)
    ])
  ], 4))
}
}

}